export class DefaultSettingsModel {
	defaultBranchId?: string;
	defaultBranchName?: string;
	defaultClientId?: string;
	defaultClientName?: string;
	defaultAppScopeUserCreation?: string;
	clients?: Array<any> ;
	fncClientId?: string;
	defaultClassOrganizationId?: string;
	defaultClassOrganizationName?: string;
	defaultMarginCap?: number = 0;
}

export class BranchModel {
	id?: string;
	title?: string;
}

export class MilestoneMessageModel {
	id?: string;
	status?: string;
	origin?: string;
	message?: string;
	sendConfirmationToOrigin: boolean;
}
